const e={PAN:"Please enter a valid credit card number",EXPIRY:"Please enter a valid expiration date",CVV:"Please enter your card's security code (CVV/CID)",NOT_VALID_CVV:"Please enter a valid security code (CVV/CID)"};export{e as PAYMENT_OS_ERRORS};
//# sourceMappingURL=paymentErrors.js.map
